import type { Product, Document, TabSection } from './eto-app';
import CustomSelect from './custom-select';

function DocumentSection({ componentName, componentsLoading, error, documents, components, tab, setActiveSubsection, i18n }: {
    componentName: string;
    componentsLoading: boolean;
    error: string | null;
    documents: Record<string, Document[]>;
    components: Product[];
    tab: TabSection | undefined;
    setActiveSubsection: (tabName: string, subtabName: string | null, subsectionName: string) => void;
    i18n: (key: string) => string;
}) {
    const librarySearchTerm = components.filter((component) => component.id).length > 0 ? components.map((component) => component.id).join(',') : new URLSearchParams(window.location.search).get('.S') || '';
    return (
        <>
            {componentsLoading &&
                <tbody>
                    {new Array(6).fill(0).map((_, index) => (
                        <tr key={index} className={`${componentName}__table-row ${componentName}__table-row-skeleton`}>
                            <th className={`${componentName}__table-cell-skeleton`}>
                                <div className={`${componentName}__table-cell-skeleton-content ${componentName}__loading-animation`}></div>
                            </th>
                            <td className={`${componentName}__table-cell-skeleton`}>
                                <div className={`${componentName}__table-cell-skeleton-content ${componentName}__loading-animation`}></div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            }
            {!componentsLoading && !error && tab && documents &&
                <>
                    {/* {components.filter((component) => component.hasDocuments).length > 0 && (
                        <div className={`${componentName}__spec-filter`}>
                            <CustomSelect
                                componentName={componentName}
                                className={`${componentName}__spec-filter-select`}
                                ariaLabel={i18n('Filter by component')}
                                value={tab.activeSection || 'All'}
                                options={[
                                    { value: 'All', label: i18n('All Components') },
                                    ...components.filter((component) => component.hasDocuments).map((component) => ({
                                        value: component.id,
                                        label: component.id,
                                    })),
                                ]}
                                onChange={(value) => {
                                    setActiveSubsection(tab.name, null, value);
                                }}
                                i18n={i18n}
                            />
                        </div>
                    )} */}
                    {Object.entries(documents).map(([type, documents]) => (
                        (tab.activeSection === 'All' || documents.some((document) => (document.componentIds.includes(tab.activeSection) || document.componentIds.includes('All')))) && (
                            <div key={type} className={`${componentName}__document-section`}>
                                <table className={`${componentName}__document-table`}>
                                    <thead>
                                        <tr data-catalog-numbers={documents.map((document) => document.componentIds.join(',')).join(',')}>
                                            <th className={`${componentName}__document-table-cell`}>{type.toUpperCase()}</th>
                                            <th className={`${componentName}__document-table-cell`}>{i18n('Publication').toUpperCase()}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {documents.map((document) => (
                                            (tab.activeSection === 'All' || document.componentIds.includes(tab.activeSection) || document.componentIds.includes('All')) && (
                                                <tr key={document.id} className={`${componentName}__document-table-row`} data-catalog-number={document.componentIds.join(',')}>
                                                    <td className={`${componentName}__document-table-cell`}>
                                                        <a href={document.link} target="_blank" rel="noopener noreferrer">{document.name + (document.componentIds.length === 1 ? ` (${document.componentIds[0]})` : '')}</a>
                                                    </td>
                                                    <td className={`${componentName}__document-table-cell`}>{document.publicationNumber}</td>
                                                </tr>
                                            )
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )
                    ))}
                </>
            }
            <div className={`${componentName}__document-more-info`}>
                <div className={`${componentName}__document-more-info-header`}>
                    {i18n('Looking for more documentation?')}
                </div>
                <div className={`${componentName}__document-more-info-text`}>
                    {i18n('Find curated technical documentation for this product in the Technical Documentation Center, or search our full Literature Library.')}
                </div>
                <a className={`${componentName}__document-more-info-link`} href={`https://www.rockwellautomation.com/search/ra-en-US;keyword=${librarySearchTerm};activeTab=Literature;`}>
                    {i18n('Search the Literature Library')}
                    <span className={`${componentName}__document-more-info-link-icon`} aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">    <path d="M12.446 7.514l5.474 8.88-5.455 8.063a.8.8 0 1 0 1.325.897l5.745-8.491a.799.799 0 0 0 .018-.868l-5.745-9.32a.8.8 0 0 0-1.362.839z"></path></svg>
                    </span>
                </a>
            </div>
        </>
    );
}

export default DocumentSection;